import styled from "styled-components";
import {dialogTextMixin} from "../../../modal-dialog/boxes/text/dialog-text.box";

export const JackpotToastSuggestedGamesTitleDefaultBox = styled.div`
    ${dialogTextMixin};
    padding: 0.8rem 0 0.5rem;
    font-size: 1.4rem;
`;